import { PREVIOUS_PAGE_TOOLTIP, NEXT_PAGE_TOOLTIP } from "utils/hiddenToolTips";
import { MdNavigateBefore, MdNavigateNext } from "react-icons/md";
import { HStack } from "../../../styled-system/jsx";
import { Button } from "../../components/core/basic/Button";
import { TooltipTrigger } from "react-aria-components";
import { Tooltip } from "../../components/core/basic/Tooltip";
import { css } from "../../../styled-system/css";

interface Props {
  data: unknown[];
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  pageSize: number;
}

const Pagination = ({ data, currentPage, setCurrentPage, pageSize }: Props) => {
  const lastPage = Math.ceil(data.length / pageSize);

  return (
    <HStack fontSize={"small"}>
      <TooltipTrigger delay={0} closeDelay={0}>
        <Button
          variant={"contentOnly"}
          onPress={() => {
            setCurrentPage((prev) => prev - 1);
          }}
          isDisabled={currentPage === 1}
          className={css({
            fontSize: "xxlarge",
            fontWeight: "bold",
          })}
        >
          <MdNavigateBefore />
        </Button>
        <Tooltip offset={10}>{PREVIOUS_PAGE_TOOLTIP}</Tooltip>
      </TooltipTrigger>
      <span>
        {currentPage} / {lastPage ? lastPage : 1}
      </span>
      <TooltipTrigger delay={0} closeDelay={0}>
        <Button
          variant={"contentOnly"}
          onPress={() => {
            setCurrentPage(currentPage + 1);
          }}
          isDisabled={currentPage === lastPage}
          className={css({
            fontSize: "xxlarge",
            fontWeight: "bold",
          })}
        >
          <MdNavigateNext />
        </Button>
        <Tooltip offset={10}>{NEXT_PAGE_TOOLTIP}</Tooltip>
      </TooltipTrigger>
    </HStack>
  );
};

export default Pagination;
